const DeviceIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
		<path
			d="M1.5 11.8333H16.5M4 1H14C14.4602 1 14.8333 1.3731 14.8333 1.83333V8.5C14.8333 8.96024 14.4602 9.33333 14 9.33333H4C3.53976 9.33333 3.16667 8.96024 3.16667 8.5V1.83333C3.16667 1.3731 3.53976 1 4 1Z"
			stroke="var(--black-color)"
			strokeOpacity="0.85"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default DeviceIcon;
